define('models/MessageCollection',[
        'app',
        'underscore',
        'jquery',
        'ObjectCollection',
        'models/MessageModel',
        'LocalStorage'
    ],
    function (app, _, $, ObjectCollection, MessageModel, LocalStorage) {

        var MessageCollectionPrototype = {

            name: 'MessageCollection',
            route: 'apiMessageCollection',
            idAttribute: 'id_sushi_message',
            comparator: 'priority_with_id', // basé sur la proprité `priority` et l'id le plus récent
            // attention j'ai fait ce comparator mais juste pour pouvoir jouer avec les id
            model:MessageModel,

            initialize: function () {
                var collection = this;
                ObjectCollection.prototype.initialize.apply(collection, arguments);
                collection.listenTo(app,'ws__new_shop_message',collection.wsNewMessage);
                collection.listenTo(app,'ws__remove_shop_message',collection.wsRemoveMessage);
            },
            fetchAndReset: function (){
                this.fetch({reset:true});
            },
            wsNewMessage:function(wsMessage){
                // ajoute merge le message à la pile (add|update).
                var newMessage = new MessageModel(wsMessage.data);
                if(newMessage.validateContext()){
                    this.set([wsMessage.data],{remove: false});
                }else{
                    this.wsRemoveMessage(wsMessage);
                }
            },
            wsRemoveMessage:function(wsMessage){
                // suppression d'un message via WS
                this.remove([wsMessage.data])
            },
            getMessageById: function (id) {
                return this.get(id+'');
                //return this.findWhere({id_sushi_message: id.toString()});
            },
            getByLocation: function (location) {
                // TODO peut-être ajouté des notions de filtre (vu/pas vu) ?
                var collection = this;
                if(location === 'shop_info'){
                    return collection.find(function(message){
                        return message.validateTime();
                    });
                }else{
                    return collection.find(function(message){
                        var isMatch = _.isMatch(message.attributes,{location: location, dismissed:false});
                        return isMatch
                            && message.validateTime();

                    });
                }
            },


        };

        return ObjectCollection.extend(MessageCollectionPrototype);
    });

